// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { IConsultarEstatisticaRequest, Types } from './types';

export function consultarEstatisticaRequest(
	token: string,
	payload: IConsultarEstatisticaRequest,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_ESTATISTICA_REQUEST,
		token,
		payload,
	};
}

export function consultarEstatisticaSuccess(
	payload: object,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_ESTATISTICA_SUCCESS,
		payload,
	};
}

export function consultarEstatisticaFailure(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_ESTATISTICA_FAILURE,
		payload: null,
	};
}

export function consultarEstatisticaClear(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_ESTATISTICA_CLEAR,
		payload: null,
	};
}
